/**
 * @generated SignedSource<<660d924b4dfb0e749e9ac72ec5a49b5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportProductsTableRowFragment$data = {
  readonly creationDatetime: string;
  readonly engagementScoreReport: {
    readonly allTime: number;
  };
  readonly id: string;
  readonly lastActivityAt: string | null;
  readonly product: {
    readonly curriculumId: string | null;
    readonly type: ProductType;
    readonly " $fragmentSpreads": FragmentRefs<"ProductWithDetailsFragment">;
  };
  readonly timeSpentSeconds: number;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportPathwayProgressFragment" | "EventAttendanceProgressBarFragment" | "MemberCurriculumProgressBarFragment">;
  readonly " $fragmentType": "AdminMembersReportProductsTableRowFragment";
};
export type AdminMembersReportProductsTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportProductsTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportProductsTableRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportProductsTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "curriculumId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductWithDetailsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDatetime",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberCurriculumProgressBarFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendanceProgressBarFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "engagementScoreReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastActivityAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeSpentSeconds",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AdminMembersReportPathwayProgressFragment"
    }
  ],
  "type": "ProductMembership",
  "abstractKey": null
};

(node as any).hash = "29b2319b48fe0d897e1be9c7f80e8fad";

export default node;
